// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const OpenPipFacets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    metricsFacet: t.struct({
        allowedMetrics: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedMetrics: t.list(KeyValuePair)
    }),
    pipTypesFacet: t.struct({
        allowedTypes: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedTypes: t.list(KeyValuePair)
    })
}, 'OpenPipFacets');

export const getDefaultState = () =>
    new OpenPipFacets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        metricsFacet: {
            allowedMetrics: [],
            isInitialLoad: true,
            selectedMetrics: []
        },
        pipTypesFacet: {
            allowedTypes: [],
            isInitialLoad: true,
            selectedTypes: []
        }
    });

export default OpenPipFacets;



// WEBPACK FOOTER //
// ./src/pip/open-pips/state/facets.js